import { defineComponent, watch, ref, getCurrentInstance } from "vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        handleSizeChange: {
            type: definePropType(Function),
            default: function() {}
        },
        handleCurrentChange: {
            type: definePropType(Function),
            default: function() {}
        },
        currentPage: {
            type: Number,
            default: 1
        },
        page_size: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
        page_sizes: {
            type: definePropType(Array),
            default: function() {
                return [
                    10,
                    20,
                    30,
                    40,
                    50,
                    100
                ];
            }
        }
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var thisCurrentPage = ref(props.currentPage);
        var pageShow = ref(true);
        watch(function() {
            return props.currentPage;
        }, function(page) {
            pageShow.value = false;
            root.$nextTick(function() {
                thisCurrentPage.value = page;
                pageShow.value = true;
            });
        }, {
            immediate: true
        });
        return {
            thisCurrentPage: thisCurrentPage,
            pageShow: pageShow
        };
    }
});
